<template>
  <b-container fluid>
    <b-row class="kasssa">
      <b-col xs="12" md="12" lg="12" xl="12">
        <h5 class="mb-0">{{ $t("Касса сверкаси")}}</h5>
      </b-col>
      <b-col lg="2" class="my-1">
        <label for="">{{ $t("Вақт") }} 1</label>
        <input class="form-control" type="date" v-model="datas.date1" />
      </b-col>
      <b-col lg="2" class="my-1">
        <label for="">{{ $t("Вақт") }} 2</label>
        <input class="form-control" type="date" v-model="datas.date2" />
      </b-col>
      <b-col lg="2" class="my-1">
        <label>Склад</label>
        <v-select class="form-control-sm md-input" :options="skladlist" v-model="datas.sklad_id" :clearable="false"
          :disabled="skladhave" :reduce="name => name.id" label="name">
          <template #search="{ attributes, events }">
            <input class="vs__search" v-bind="attributes" v-on="events" aria-activedescendant="null" />
          </template>
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              <em><b>{{ search }}</b></em>
              {{ $t("бўйича маьлумот йўқ") }}
            </template>
            <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
          </template>
        </v-select>
      </b-col>
      <b-col lg="3" class="my-1">
        <label for="">{{$t('Тўлов тури')}}</label>
        <v-select class="form-control-sm md-input filt" :options="paytypelist" v-model="filtertype" :clearable="false"
          multiple :reduce="name => name.id" label="name">
        </v-select>
      </b-col>
      <b-col lg="3" class="my-1">
        <br /><button type="button" class="btn mybtn" @click="Send()">
          {{ $t("Кўриш") }}
        </button>
        <button type="button" class="btn mybtn" @click="downloadExl">
          <b-icon icon="cloud-download"></b-icon> {{ $t("Excel(Юклаш)") }}
        </button>
        <button type="button" class="btn mybtn" @click="Print()">
          <b-icon icon="printer"></b-icon>
        </button>
      </b-col>
      <!-- <pre>
        {{results}}
      </pre> -->
      <div class="limiter" id="tableId">
        <div class="container-table100">
          <div class="wrap-table100">
            <div class="table100 tworow ver1 m-b-110">
              <div class="table100-head">
                <table>
                  <thead>
                    <tr class="row100 head">
                      <th class="cell100 column0" rowspan="2">#</th>
                      <th class="cell100" rowspan="2">{{ $t("Номи") }}</th>
                      <th class="cell100 column2" rowspan="2">
                        {{ $t("Вақт") }}
                      </th>
                      <th class="cell100 column2" rowspan="2">
                        {{ $t("Комментарий") }}
                      </th>
                      <th class="cell100 column2" rowspan="2">
                        {{ $t("Сабаб") }}
                      </th>
                      <th class="cell100 column2" rowspan="2">
                        {{ $t("Фойдаланувчи") }}
                      </th>
                      <th class="cell100" colspan="2" v-if="Filtercolumn(1)==1">{{ $t("Нахд") }}</th>
                      <th class="cell100" colspan="2" v-if="Filtercolumn(2)==1">Пластик</th>
                      <th class="cell100" colspan="2" v-if="Filtercolumn(4)==1">Перечесления</th>
                      <th class="cell100" colspan="2" v-if="Filtercolumn(3)==1">Доллар</th>
                    </tr>
                    <tr class="row100 head">
                      <th class="cell100 column1-5" v-if="Filtercolumn(1)==1">{{ $t("Кирим") }}</th>
                      <th class="cell100 column1-5" v-if="Filtercolumn(1)==1">{{ $t("Расход") }}</th>
                      <th class="cell100 column1-5" v-if="Filtercolumn(2)==1">{{ $t("Кирим") }}</th>
                      <th class="cell100 column1-5" v-if="Filtercolumn(2)==1">{{ $t("Расход") }}</th>
                      <th class="cell100 column1-5" v-if="Filtercolumn(4)==1">{{ $t("Кирим") }}</th>
                      <th class="cell100 column1-5" v-if="Filtercolumn(4)==1">{{ $t("Расход") }}</th>
                      <th class="cell100 column1-5" v-if="Filtercolumn(3)==1">{{ $t("Кирим") }}</th>
                      <th class="cell100 column1-5" v-if="Filtercolumn(3)==1">{{ $t("Расход") }}</th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div class="table100-body summatable">
                <table>
                  <tr>
                    <td class="cell100" colspan="6">
                      {{ $t("Бошланғич қолдиқ") }}
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(1)==1">
                      <span v-if="results.begin">{{
                        (results.begin.kirim_cash - results.begin.chiqim_cash)
                        | numFormats
                        }}</span><span v-else>0</span>
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(1)==1"></td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(2)==1">
                      <span v-if="results.begin">{{
                        (results.begin.kirim_plastic -
                        results.begin.chiqim_plastic)
                        | numFormats
                        }}</span><span v-else>0</span>
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(2)==1"></td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(4)==1">
                      <span v-if="results.begin">{{
                        (results.begin.kirim_shot -
                        results.begin.chiqim_shot)
                        | numFormats
                        }}</span><span v-else>0</span>
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(4)==1"></td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(3)==1">
                      <span v-if="results.begin">{{
                        (results.begin.kirim_dollar -
                        results.begin.chiqim_dollar)
                        | numFormats
                        }}</span><span v-else>0</span>
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(3)==1"></td>
                  </tr>
                </table>
              </div>
              <div class="table100-body sverka js-pscroll">
                <table>
                  <tbody>
                    <tr class="row100 body" v-for="(item, index) in results.data" :key="index" @click="Clicked(item)">
                      <td class="cell100 column0">
                        {{ index + 1 }}
                      </td>
                      <td class="cell100">
                        {{ item.doc_type }} № {{ item.doc_id }}
                      </td>
                      <td class="cell100 column2">
                        {{ Dates(item.datetime) }}
                      </td>
                      <td class="cell100 column2">
                        {{ item.comment}}
                      </td>
                      <td class="cell100 column2">
                        {{ item.reason }}
                      </td>
                      <td class="cell100 column2">
                        <span v-if="item.user">
                          {{ item.user.first_name }}
                        </span>
                      </td>
                      <td class="cell100 column1-5 kol" v-if="Filtercolumn(1)==1">
                        {{ item.kirim_cash | numFormats }}
                      </td>
                      <td class="cell100 column1-5 kol" v-if="Filtercolumn(1)==1">
                        {{ item.chiqim_cash | numFormats }}
                      </td>
                      <td class="cell100 column1-5 kol" v-if="Filtercolumn(2)==1">
                        {{ item.kirim_plastic | numFormats }}
                      </td>
                      <td class="cell100 column1-5 kol" v-if="Filtercolumn(2)==1">
                        {{ item.chiqim_plastic | numFormats }}
                      </td>
                      <td class="cell100 column1-5 kol" v-if="Filtercolumn(4)==1">
                        {{ item.kirim_shot | numFormats }}
                      </td>
                      <td class="cell100 column1-5 kol" v-if="Filtercolumn(4)==1">
                        {{ item.chiqim_shot | numFormats }}
                      </td>
                      <td class="cell100 column1-5 kol" v-if="Filtercolumn(3)==1">
                        {{ item.kirim_dollar | numFormats }}
                      </td>
                      <td class="cell100 column1-5 kol" v-if="Filtercolumn(3)==1">
                        {{ item.chiqim_dollar | numFormats }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="table100-body summatable1">
                <table>
                  <tr>
                    <td class="cell100" colspan="6">{{ $t("Жами") }}</td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(1)==1">
                      <span v-if="results.summ">{{
                        results.summ.kirim_cash | numFormats
                        }}</span>
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(1)==1">
                      <span v-if="results.summ">{{
                        results.summ.chiqim_cash | numFormats
                        }}</span>
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(2)==1">
                      <span v-if="results.summ">{{
                        results.summ.kirim_plastic | numFormats
                        }}</span>
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(2)==1">
                      <span v-if="results.summ">{{
                        results.summ.chiqim_plastic | numFormats
                        }}</span>
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(4)==1">
                      <span v-if="results.summ">{{
                        results.summ.kirim_shot | numFormats
                        }}</span>
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(4)==1">
                      <span v-if="results.summ">{{
                        results.summ.chiqim_shot | numFormats
                        }}</span>
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(3)==1">
                      <span v-if="results.summ">{{
                        results.summ.kirim_dollar | numFormats
                        }}</span>
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(3)==1">
                      <span v-if="results.summ">{{
                        results.summ.chiqim_dollar | numFormats
                        }}</span>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="table100-body summatable">
                <table>
                  <tr>
                    <td class="cell100" colspan="6">
                      {{ $t("Якуний қолдиқ") }}
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(1)==1">
                      <span v-if="results.end">{{
                        (results.end.kirim_cash - results.end.chiqim_cash)
                        | numFormats
                        }}</span>
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(1)==1">
                      <span v-if="results.end"></span>
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(2)==1">
                      <span v-if="results.end">{{
                        (results.end.kirim_plastic -
                        results.end.chiqim_plastic)
                        | numFormats
                        }}</span>
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(2)==1">
                      <span v-if="results.end"></span>
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(4)==1">
                      <span v-if="results.end">{{
                        (results.end.kirim_shot -
                        results.end.chiqim_shot)
                        | numFormats
                        }}</span>
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(4)==1">
                      <span v-if="results.end"></span>
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(3)==1">
                      <span v-if="results.end">{{
                        (results.end.kirim_dollar -
                        results.end.chiqim_dollar)
                        | numFormats
                        }}</span>
                    </td>
                    <td class="cell100 column1-5 kol" v-if="Filtercolumn(3)==1">
                      <span v-if="results.end"></span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-row>
    <paytype :datas="datas"></paytype>
    <sklad :datas="datas"></sklad>
    <unit></unit>
    <model></model>
    <brand></brand>
    <colour></colour>
  </b-container>
</template>

<script>
  var XLSX = require("xlsx");
  var FileSaver = require("file-saver");

  import { Paytype, Unit, Model, Brand, Colour, Sklad } from "@/pages";
  import { print } from "../../../components/mixins/print.js";
  export default {
    components: { Paytype, Unit, Model, Brand, Colour, Sklad },
    data() {
      return {
        filtertype: [1, 2, 3, 4],
        datas: {
          date1: new Date().toISOString().slice(0, 10),
          date2: new Date().toISOString().slice(0, 10),
          pay_type_id: null,
          sklad_id: parseInt(localStorage.getItem("sklad_id"))
        },
        paytype: "",
        paytypelist: [],
        sklad: "",
        skladlist: [],
        errors: "",
        results: []
      };
    },
    mixins: [print],
    created() {
      let self = this;
      self.$root.$on("paytypeone", function (getdata) {
        self.paytype = getdata;
      });
      self.$root.$on("paytypeall", function (getdata) {
        self.paytypelist = getdata;
      });
      self.$root.$on("skladone", function (getdata) {
        self.sklad = getdata;
      });
      self.$root.$on("skladall", function (getdata) {
        self.skladlist = getdata;
      });
    },
    methods: {
      Filtercolumn(type) {
        let oddNumbers = this.filtertype.filter(number => number == type);
        return oddNumbers.length;
      },
      Clicked(item) {
        let self = this;
        var doc_type = item.doc_type;
        if (item.doc_type == 'Перевод денег') {
          doc_type = 'Перемешения касса';
        }
        let index = this.$router.resolve({ name: doc_type });
        axios({
          method: "post",
          url: "api/v1/users/rule-by-path",
          data: { path: index.route.path }
        }).then(function (response) {
          if (response.data.see == true) {
            let routeData = self.$router.resolve({ name: item.doc_type + ' ўзгартириш', params: { id: item.doc_id } });
            console.log(routeData.href);
            window.open(routeData.href, "_blank", "width=1200, height=1000");
          } else {
            self.$store.state.errors = self.$t('Sizdan bunday xuquq mavjud emas');
          }
        });
      },
      downloadExl() {
        this.$store.state.xls = true;
        setTimeout(() => {
          let wb = XLSX.utils.table_to_book(document.getElementById("tableId")),
            wopts = {
              bookType: "xlsx",
              bookSST: false,
              type: "binary"
            };
          var wscols = [{ width: 5 }, { width: 28 }, { width: 20 }, { width: 20 }, { width: 13 }, { width: 13 }, { width: 13 }, { width: 13 }, { width: 13 }, { width: 13 }];
          wb.Sheets.Sheet1['!cols'] = wscols;
          let wbout = XLSX.write(wb, wopts);
          FileSaver.saveAs(
            new Blob([this.s2ab(wbout)], {
              type: "application/octet-stream;charset=utf-8"
            }),
            new Date() + "kassa_kniga.xlsx"
          );
          setTimeout(() => {
            this.$store.state.xls = false;
          }, 2000);
        }, 2000);
      },
      s2ab(s) {
        if (typeof ArrayBuffer !== "undefind") {
          var buf = new ArrayBuffer(s.length);
          var view = new Uint8Array(buf);
          for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
          return buf;
        } else {
          var buf = new Array(s.length);
          for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xff;
          return buf;
        }
      },
      Send() {
        let self = this;
        var datas = {
          datetime1: parseInt(
            new Date(self.datas.date1)
              .valueOf()
              .toString()
              .slice(0, 10)
          ),
          datetime2:
            parseInt(
              new Date(self.datas.date2)
                .valueOf()
                .toString()
                .slice(0, 10)
            ) + 86399,
          sklad_id: self.datas.sklad_id
        };
        axios({
          method: "post",
          url: "api/v1/akt-sverka/kassa-book",
          headers: {
            "Content-Type": "application/json"
          },
          data: datas
        }).then(function (response) {
          self.results = response.data;
          self.results.summ = {
            kirim_cash: 0,
            chiqim_cash: 0,
            kirim_plastic: 0,
            chiqim_plastic: 0,
            kirim_shot: 0,
            chiqim_shot: 0,
            kirim_dollar: 0,
            chiqim_dollar: 0
          };
          self.results.data.forEach(function (key, value) {
            self.results.summ.kirim_cash += parseFloat(key.kirim_cash);
            self.results.summ.chiqim_cash += parseFloat(key.chiqim_cash);
            self.results.summ.kirim_plastic += parseFloat(key.kirim_plastic);
            self.results.summ.chiqim_plastic += parseFloat(key.chiqim_plastic);
            self.results.summ.kirim_shot += parseFloat(key.kirim_shot);
            self.results.summ.chiqim_shot += parseFloat(key.chiqim_shot);
            self.results.summ.kirim_dollar += parseFloat(key.kirim_dollar);
            self.results.summ.chiqim_dollar += parseFloat(key.chiqim_dollar);

          });
        });
      }
    }
  };
</script>
<style>
@media (max-width: 1268px) {
  .kasssa .column1-5 {
    width: 60px !important;
  }

  .kasssa .column0 {
    width: 30px !important;
  }

  .kasssa .column2 {
    width: 70px !important;
  }
  .kasssa .table100.ver1 th {
    font-size: 11px !important;
  }

  .kasssa .table100.ver1 td {
    font-size: 11px !important;
  }
}
  .kasssa .column1-5 {
    width: 95px;
  }

  .kasssa .column0 {
    width: 40px;
  }

  .kasssa .column2 {
    width: 120px;
  }

  .kasssa .table100.ver1 th {
    font-size: 12px;
  }

  .kasssa .table100.ver1 td {
    word-wrap: break-word !important;
    word-break: break-word !important;
    font-size: 12px !important;
  }

  .kasssa .filt .vs__selected {
    position: inherit !important;
  }
</style>